import { render, staticRenderFns } from "./IndividualRecord.vue?vue&type=template&id=0500ab62&scoped=true"
import script from "./IndividualRecord.vue?vue&type=script&lang=js"
export * from "./IndividualRecord.vue?vue&type=script&lang=js"
import style0 from "./IndividualRecord.vue?vue&type=style&index=0&id=0500ab62&prod&lang=scss&scoped=true"
import style1 from "./IndividualRecord.vue?vue&type=style&index=1&id=0500ab62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0500ab62",
  null
  
)

export default component.exports